// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let PageUITitle = require("../../components/PageTitle/PageUITitle.bs.js");
let ContentBox__Jsx3 = require("../../uikit/reason/atoms/ContentBox/ContentBox__Jsx3.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let TMPUIKIT____Page = require("../../temporaryUIKit/TMPUIKIT____Page/TMPUIKIT____Page.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let BillingSettingsPagePaymentCard = require("./BillingSettingsPagePaymentCard.bs.js");
let BillingSettingsPageSubscription = require("./BillingSettingsPageSubscription.bs.js");
let BillingSettingsPageRelayQuery_graphql = require("../../__generated__/BillingSettingsPageRelayQuery_graphql.bs.js");
let BillingSettingsPageRelay_accountV5_graphql = require("../../__generated__/BillingSettingsPageRelay_accountV5_graphql.bs.js");

let convertFragment = BillingSettingsPageRelay_accountV5_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, BillingSettingsPageRelay_accountV5_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(BillingSettingsPageRelay_accountV5_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, BillingSettingsPageRelay_accountV5_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(BillingSettingsPageRelay_accountV5_graphql.node, convertFragment, fRef);
}

let AccountFragment_planType_decode = BillingSettingsPageRelay_accountV5_graphql.Utils.planType_decode;

let AccountFragment_planType_fromString = BillingSettingsPageRelay_accountV5_graphql.Utils.planType_fromString;

let AccountFragment = {
  planType_decode: AccountFragment_planType_decode,
  planType_fromString: AccountFragment_planType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertVariables = BillingSettingsPageRelayQuery_graphql.Internal.convertVariables;

let convertResponse = BillingSettingsPageRelayQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = BillingSettingsPageRelayQuery_graphql.Internal.convertWrapRawResponse;

let use$1 = RescriptRelay_Query.useQuery(convertVariables, BillingSettingsPageRelayQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, BillingSettingsPageRelayQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(BillingSettingsPageRelayQuery_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch(BillingSettingsPageRelayQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(BillingSettingsPageRelayQuery_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(BillingSettingsPageRelayQuery_graphql.node, convertVariables);

let Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use$1,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function BillingSettingsPageRelay(props) {
  let data = use$1(undefined, undefined, undefined, undefined);
  let account = RescriptRelay_Fragment.useFragment(BillingSettingsPageRelay_accountV5_graphql.node, convertFragment, data.currentAccountV5.fragmentRefs);
  let match = account.sub.plan.planType;
  let tmp;
  let exit = 0;
  if (match === "FREE") {
    tmp = null;
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp = JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(TMPUIKIT____Page.Subtitle.make, {
          children: "Payment Method"
        }),
        JsxRuntime.jsx(BillingSettingsPagePaymentCard.make, {
          account: account.fragmentRefs
        })
      ]
    });
  }
  return JsxRuntime.jsxs(ContentBox__Jsx3.make, {
    paddingFull: true,
    hasShadow: true,
    children: [
      JsxRuntime.jsx(PageUITitle.make, {
        title: "Billing"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          tmp,
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(TMPUIKIT____Page.Subtitle.make, {
                children: "Current Subscription"
              }),
              JsxRuntime.jsx(BillingSettingsPageSubscription.make, {
                account: account.fragmentRefs
              })
            ]
          })
        ],
        className: "flex flex-col gap-8"
      })
    ]
  });
}

let SubTitle;

let make = BillingSettingsPageRelay;

exports.AccountFragment = AccountFragment;
exports.Query = Query;
exports.SubTitle = SubTitle;
exports.make = make;
/* use Not a pure module */
